import { Component, type ReactNode } from 'react'

interface State {
  error: Error | null
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: unknown) {
    console.error('App crashed:', error, info)
  }

  render() {
    const { error } = this.state
    if (error == null) return this.props.children
    return (
      <div className="absolute inset-0 z-50 overflow-auto bg-red-950/95 p-6 text-sm text-red-100">
        <h2 className="mb-3 text-lg font-semibold">App error</h2>
        <pre className="whitespace-pre-wrap break-words">
          {error.message}
          {'\n\n'}
          {error.stack}
        </pre>
      </div>
    )
  }
}
